// components
import CalendarHeader from './components/CalendarHeader/CalendarHeader';

// styles
import { CalendarPanel } from './CalendarWrapper.styles';
import { CalendarWrapperProps } from './CalendarWrapper.types';

// stores
import { useDateNavigationStore } from 'components/shared/DateNavigation/DateNavigation.stores';

const CalendarWrapper = ({ children, displayData }: CalendarWrapperProps) => {
  'use memo';
  const periodType = useDateNavigationStore((state) => state.period);

  return (
    <CalendarPanel
      className="single-tab-panel"
      size={periodType === 'day' ? 'SLIM' : 'FULL'}
    >
      <CalendarHeader displayData={displayData} />

      {children}
    </CalendarPanel>
  );
};

export default CalendarWrapper;
